import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Happy Birthday Tisha',
    description: "Tisha mate ek khas birthday surprise: apdi kahani, apdi yaado, ek love letter ane bhou badho prem.",
    url: getOrigin()
}
